import { render } from "./restore-password.vue?vue&type=template&id=5b6fcea6"
import script from "./restore-password.vue?vue&type=script&lang=js"
export * from "./restore-password.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__